// Full searchable radio details from the supplied 2023 statewide channel plan.
export default String.raw`19.1|151.22000|192.8|151.22000|192.8|L|N|CDF Air-to-Ground 1
19.2|159.26250|192.8|159.26250|192.8|L|N|CDF Air-to-Ground 2
19.3|159.36750|192.8|159.36750|192.8|L|N|CDF Air-to-Ground 3
19.4|159.22500|192.8|159.22500|192.8|L|N|CDF Air-to-Ground 4
19.5|159.27000|192.8|159.27000|192.8|L|N|CDF Air-to-Ground 5
19.6|159.28500|192.8|159.28500|192.8|L|N|CDF Air-to-Ground 6
19.7|159.31500|192.8|159.31500|192.8|L|N|CDF Air-to-Ground 7
19.8|159.34500|192.8|159.34500|192.8|L|N|CDF Air-to-Ground 8
19.9|159.36000|192.8|159.36000|192.8|L|N|CDF Air-to-Ground 9
19.10|159.37500|192.8|159.37500|192.8|L|N|CDF Air-to-Ground 10
19.11|159.39000|192.8|159.39000|192.8|L|N|CDF Air-to-Ground 11
19.12|159.40500|192.8|159.40500|192.8|L|N|CDF Air-to-Ground 12
19.13|159.45000|192.8|159.45000|192.8|L|N|CDF Air-to-Ground 13
19.14|151.33250|192.8|151.33250|192.8|L|N|CDF Air-to-Ground 14
19.15|159.27750|192.8|159.27750|192.8|L|N|CDF Air-to-Ground 15
19.16|151.37750|192.8|151.37750|192.8|L|N|CDF Air-to-Ground 16
19.17|151.28000|110.9|000.00000|000.0||N|CDF licensed freq RX only
19.18|151.29500|110.9|000.00000|000.0||N|CDF licensed freq RX only
19.19|151.31000|110.9|000.00000|000.0||N|CDF licensed freq RX only
19.20|151.27250|110.9|000.00000|000.0||N|CDF licensed freq RX only
19.21|151.28750|110.9|000.00000|000.0||N|CDF licensed freq RX only
19.22|151.30250|110.9|000.00000|000.0||N|CDF licensed freq RX only
19.23|151.36250|110.9|000.00000|000.0||N|CDF licensed freq RX only
19.24|154.40000|151.4|154.40000|151.4|L|N|LA County Air-to-Ground
19.25|154.83000|100.0|154.83000|100.0|L|N|LA Fire Dept Air-to-Ground
19.26|155.70000|192.8|155.70000|192.8|L|N|Rvrcd County Air-to-Ground
19.27|154.23500|167.9|154.23500|167.9|L|N|Ventura County Air-to-Grnd
19.28|154.89000|167.9|154.89000|167.9|L|N|Kern County Air-to-Ground
19.29|156.16500|107.2|156.16500|107.2|L|N|SAN DIEGO CO. A/G 1
19.30|156.12000|107.2|156.12000|107.2|L|N|SAN DIEGO CO. A/G 2 (NEW)
19.31|153.90500|107.2|153.90500|107.2|L|N|SAN DIEGO CO. A/G 3 (NEW)
19.32|153.96500|167.9|153.96500|167.9|L|N|
19.33|168.56250|000.0|168.56250|000.0|L|N|YOSEMITE AIR TO GROUND
19.34|167.60000|000.0|167.60000|000.0|L|N|Air-to-Ground 43
19.35|166.87500|000.0|166.87500|000.0|L|N|Air-to-Ground 8
19.36|167.50000|000.0|167.50000|000.0|L|N|Air-to-Ground 14
19.37|169.11250|000.0|169.11250|000.0|L|N|Air-to-Ground 59
19.38|167.47500|000.0|167.47500|000.0|L|N|Air-to-Ground 41
19.39|168.63750|000.0|168.63750|000.0|L|N|Air-to-Ground 24
19.40|168.48750|000.0|168.48750|000.0|L|N|Air-to-Ground 53
19.41|163.10000|000.0|163.10000|000.0|L|N|NIFC Deck Use Only
19.42|168.35000|000.0|168.35000|000.0|L|N|NIFC Deck Use Only
19.43|168.61250|000.0|168.61250|000.0|L|N|NIFC Deck Use Only
19.44|166.61250|000.0|166.61250|000.0|L|N|A/A or A/G (NIFC)
19.45|167.95000|000.0|167.95000|000.0|L|N|A/A or A/G (NIFC)
19.46|168.40000|000.0|168.40000|000.0|L|N|A/A or A/G (NIFC)
19.47|169.15000|000.0|169.15000|000.0|L|N|A/A or A/G (NIFC)
19.48|169.20000|000.0|169.20000|000.0|L|N|A/A or A/G (NIFC)
19.49|173.67500|000.0|173.67500|000.0|L|N|SEQUOIA NP A/G
19.50|162.75000|000.0|000.00000|000.0||N|FED Receive only
19.51|163.16250|000.0|000.00000|000.0||N|FED Receive only
19.52|164.13750|000.0|000.00000|000.0||N|FED Receive only
19.53|164.78750|000.0|000.00000|000.0||N|FED Receive only
19.54|164.93750|000.0|000.00000|000.0||N|FED Receive only
19.55|165.01250|000.0|000.00000|000.0||N|FED Receive only
19.56|167.70000|000.0|000.00000|000.0||N|FED Receive only
19.57|168.83750|000.0|000.00000|000.0||N|FED Receive only
19.58|169.12500|000.0|000.00000|000.0||N|FED Receive only
19.59|169.17500|000.0|000.00000|000.0||N|FED Receive only
19.60|166.98750|000.0|000.00000|000.0||N|FED Receive only
19.61|167.30000|000.0|000.00000|000.0||N|FED Receive only
20.1|136.0000|0.0|136.0000|.0.0|H|N|`;
